import { useEffect, useState } from "react"
import DateCard from "../components/DateCard"
import img0 from '../assets/person0.jpeg'
import img1 from '../assets/person-m1.jpeg'
import img2 from '../assets/person-m2.jpeg'
import img3 from '../assets/pixel-f1.jpg'
import img4 from '../assets/pixel-f2.jpg'
import img5 from '../assets/person-f3.jpeg'
import img6 from '../assets/person-f0.jpeg'
import img7 from '../assets/person-f7.jpeg'
import { ConfirmNextButton } from "../components/ConfirmNextButton"
import NomGeocoderService from "../services/NomGeocoderService"
import { AppGeolocation } from "../models/app/AppGeolocation"
import { APP_LOGO, rootStore } from "../StApp"
import ApiService from "../services/ApiService"
import { UpdateGeolocationRequest } from "../models/api/UpdateGeolocationRequest"
import { DateshipStore } from "../stores/DateshipStore"
import { Observer, observer } from "mobx-react-lite"
import Loader from "../components/Loader"
import { motion, AnimatePresence } from "framer-motion";
import { LikesComputer } from "../stores/interfaces/LikesComputer"
import { DateshipHeader } from "../components/DateshipHeader"
import { SwipeDateStack } from "../components/SwipeDateStack"
import datingImg from '../assets/dating-app-concept.jpg'
import { Transitions } from "../transitions/pageTransitions";

const imgArr = [img6, img7, img5]

const SwipeBox = observer(({ store }: { store: DateshipStore }) => {

    function NoMoreDates() {
        return (
            <div className='flex-column center-both' >
                <h3>No more people available</h3>
                <button className='button-styled button-dump ' onClick={() => store.loadSwipeQueue()} >Refresh</button>
            </div>)
    }

    if (store.swipeLoadProg == 'LOADING') {
        if (store.swipeBuffer.length == 0)
            return (<Loader />)
    }
    else if (store.currentShownUsers.length == 0)
        return <NoMoreDates/>

    if (store.swipeLoadProg !== 'LOADING' && store.swipeBuffer.length == 0 && store.selectionMode == 'SWIPE')
        return <NoMoreDates/>

    console.log(store.swipeLoadProg)
    console.log(store.swipeBuffer.length)

    console.log(JSON.stringify(store.swipeBuffer.map(item => item.name)))

    if (store.selectionMode == 'SWIPE')
        return <SwipeDateStack />
    else {
        if (store.currentShownUsers.length > 0)
            return (
                <AnimatePresence >
                    <motion.div key={store.currentShownUsers[0].uid} className='flex-row' style={{
                        width: '100%',
                        flexWrap: 'wrap',
                        marginTop: 0,
                        position: 'absolute'
                    }}
                        initial={{ x: 300, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -300, opacity: 0 }}
                    >{
                            store.currentShownUsers.map((item, index) => <DateCard key={index} imgUrl={APP_LOGO} user={item} />)
                        }
                    </motion.div>
                </AnimatePresence>
            );
        else
            return (<Loader />)
    }

})



const SwipeModeSelector = observer(() => {

    const mode = rootStore.dateshipStore.selectionMode

    return (<div className='flex-row' style={{
        position: 'absolute',
        left: 15,
        bottom: 10
    }}>
        <span className="material-icons-round" onClick={() => rootStore.dateshipStore.updateSelectionMode('SWIPE')}
            style={{
                fontSize: 40, color: mode == 'SWIPE' ? 'purple' : 'gray'
            }}>
            swipe_right
        </span>
        <span className="material-icons-round" onClick={() => rootStore.dateshipStore.updateSelectionMode('STANDARD')}
            style={{
                fontSize: 40, color: mode == 'STANDARD' ? 'purple' : 'gray'
            }}>
            grid_view
        </span>
    </div>);
})


export const Dateship = () => {

    const [loc, setLoc] = useState(rootStore.mainStore.geoLocation)
    const [store] = useState(rootStore.dateshipStore)

    useEffect(() => {
        document.title = 'Dateship'
    }, [])

    useEffect(() => {
        if (loc != null)
            store.loadSwipeQueue()
    }, [loc])

    useEffect(() => {
        store.reloadLeftLikes()
    })

    function activateDating() {
        navigator.geolocation.getCurrentPosition((pos) => {

            var crd = pos.coords

            console.log('Your current position is:');
            console.log(`Latitude : ${crd.latitude}`);
            console.log(`Longitude: ${crd.longitude}`);
            console.log(`More or less ${crd.accuracy} meters.`);

            NomGeocoderService.geocodeFromCoord(crd.latitude, crd.longitude)
                .then(result => {
                    console.log(result)
                    let appGeolocation: AppGeolocation = {
                        lat: crd.latitude,
                        long: crd.longitude,
                        geocodedLoc: result
                    }

                    let updateLocRequest: UpdateGeolocationRequest = {
                        coord: [appGeolocation.lat, appGeolocation.long],
                        metadata: result,
                        uid: rootStore.mainStore.uid!,
                        timestamp: new Date().toISOString()
                    }

                    //Update location to server
                    ApiService.updateGeolocation({
                        auth: rootStore.mainStore.token,
                        data: updateLocRequest
                    })
                        .then(resp => {
                            console.log(resp.data)
                            rootStore.mainStore.updateGeolocation(appGeolocation)
                            setLoc(appGeolocation)
                        })
                        .catch(err => console.error(err))


                })
        })
    }

    if(!rootStore.profileStore.dateEnabled)
    return (
        <motion.div className='flex-column center-both absolute' style={{ height: '100%', width: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <h4>Please enable dating from Home</h4>
        </motion.div>
    )

    if (rootStore.mainStore.geoLocation == null)
        return (
            <motion.div className='flex-column center-both absolute' style={{ height: '100%' }}
                initial="initial"
                animate="in"
                exit="out"
                variants={Transitions.pageVariants}
                transition={Transitions.pageTransition}
            >
                <img src={datingImg} alt="" style={{ width: '100%', height: 300 }} />
                <button className='button-styled button-active-date' style={{ width: 185 }} onClick={activateDating} >Activate Dateship</button>
                <h4 style={{ textAlign: 'center', padding: 8 }}>
                    Dating requires access to your location which will be used only to show you relevant matches</h4>
            </motion.div>
        )

    return (
        <motion.div className='flex-column center-both absolute' style={{ height: '100%', width: '100%', overflow: 'hidden' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div className='flex-column center-both'  >
                <DateshipHeader store={store} ></DateshipHeader>
                <SwipeBox store={store} />
                <SwipeModeSelector></SwipeModeSelector>
                <div style={{ position: 'absolute', bottom: 10, right: 15 }} ><ConfirmNextButton /></div>
            </div>

        </motion.div>
    )
}